import { useMutation } from '@apollo/client/react';
import { Button } from 'components/ui';
import { useInfo } from 'contexts/info';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import DeleteMutation from 'mutations/session_info/delete';
import Confirmation from 'components/form/confirmation';

const DeleteButton = ({ sessionInfo, onRemove }) => {
  const setInfo = useInfo();
  const setError = useError();

  const [deleteMutation, deleteMutationData] = useMutation(DeleteMutation, {
    onCompleted: () => {
      setInfo('info.user.session_info.deleted');
      onRemove();
    },
    onError: () => {
      setError('error.session_info.delete');
    },
  });

  return (
    <Confirmation
      title={<FormattedMessage id="header.session_info.delete" />}
      description={<FormattedMessage id="confirmation.session_info.delete" />}
      onClick={() => {
        deleteMutation({ variables: { id: sessionInfo.id } });
      }}
    >
      <Button color="error" variant="outlined" disabled={deleteMutationData.loading}>
        <FormattedMessage id="button.logout" />
      </Button>
    </Confirmation>
  );
};

export default DeleteButton;
